import api from "./api";
import { tokenStorage } from "../utils/tokenStorage";

const idempotencyKey = () =>
  "docs-" + Date.now() + "-" + Math.random().toString(16).slice(2);

const withIdempotency = (headers = {}) => ({
  headers: {
    ...headers,
    "Idempotency-Key": idempotencyKey(),
  },
});

export const commercialDocumentsService = {
  // Presupuestos
  listBudgets(params) {
    return api.get("/presupuestos", { params });
  },
  getBudget(id) {
    return api.get(`/presupuestos/${id}`);
  },
  createBudget(payload) {
    return api.post("/presupuestos", payload, withIdempotency());
  },
  updateBudget(id, payload) {
    return api.patch(`/presupuestos/${id}`, payload, withIdempotency());
  },
  deleteBudget(id) {
    return api.delete(`/presupuestos/${id}`, withIdempotency());
  },
  convertBudgetToCounterInvoice(id, payload) {
    return api.post(`/presupuestos/${id}/convertir-a-factura-mostrador`, payload, withIdempotency());
  },

  // Facturación mostrador
  listCounterInvoices(params) {
    return api.get("/facturas-mostrador", { params });
  },
  getCounterInvoice(id) {
    return api.get(`/facturas-mostrador/${id}`);
  },
  getCounterInvoiceAccounting(id) {
    return api.get(`/facturas-mostrador/${id}/accounting-entry`);
  },
  createCounterInvoice(payload) {
    return api.post("/facturas-mostrador", payload, withIdempotency());
  },
  updateCounterInvoice(id, payload) {
    return api.patch(`/facturas-mostrador/${id}`, payload, withIdempotency());
  },

  // Compras
  listPurchases(params) {
    return api.get("/compras", { params });
  },
  getPurchase(id) {
    return api.get(`/compras/${id}`);
  },
  createPurchase(payload) {
    return api.post("/compras", payload, withIdempotency());
  },
  updatePurchase(id, payload) {
    return api.patch(`/compras/${id}`, payload, withIdempotency());
  },
  uploadPurchaseAttachment(id, file) {
    const formData = new FormData();
    formData.append("attachment", file);
    return api.post(`/purchases/${id}/attachment`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });
  },
  getPurchaseAttachmentUrl(id) {
    const session = tokenStorage.getSession();
    const token = session?.accessToken || '';
    return `${api.defaults.baseURL}/purchases/${id}/attachment?token=${token}`;
  }
};

export default commercialDocumentsService;
